import { Reducer } from 'redux';
import { KpiEAEState, KpiEAETypes } from './types';

const INITIAL_STATE: KpiEAEState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<KpiEAEState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case KpiEAETypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case KpiEAETypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };

    case KpiEAETypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: INITIAL_STATE.data,
      };
    default:
      return state;
  }
};

export default reducer;
